<fgb-mobile-page-header [pageTitle]="'earn.page.title'" backButtonLink="/" [showBalance]="false" [showQr]="false" />
<fgb-banner class="d-lg-block d-none" [title]="'earn.page.title' | translate" />

<div class="container mobile-container">
  <fgbcl-earn-points></fgbcl-earn-points>
</div>
